import React, { PropTypes } from 'react';
import { GoogleMapLoader, GoogleMap, Marker } from 'react-google-maps';
import MapStyles from './mapStyles.json';

class PointMap extends React.Component {
    render () {
        var point = this.props.point,
            markers;

        markers = [
            (
                <Marker
                    key={ 'point' }
                    position={ point.position }
                    title={ point.title }
                    defaultAnimation={ 2 }>
                </Marker>
            )
        ];

        return (
            <div className="gmap-point-container">
                <GoogleMapLoader 
                    containerElement={
                        <div className="gmap" />
                    }

                    googleMapElement= {
                        <GoogleMap
                            defaultZoom={ 10 }
                            defaultCenter={ point.position }
                            defaultOptions={ {
                                styles: MapStyles,
                                mapTypeControl: false,
                                streetViewControl: false,
                                zoomControl: false,
                                fullscreenControl: true
                            } }>
                            { markers }
                        </GoogleMap>
                    }
                />
            </div>
        );
    }
};

export default PointMap;


// WEBPACK FOOTER //
// ./src/app/components/googleMap/pointMap.jsx